import React from "react";
import "../Page.css";

const AddForm = () => {
  return (
    <div className="DashboardPage">
      <div className="component-card">
        <h2>Welcome to the Add Form</h2>
        <div className="coming-soon-loader">
          <span>C</span>
          <span>o</span>
          <span>m</span>
          <span>i</span>
          <span>n</span>
          <span>g</span>
          <span>&nbsp;</span>
          <span>S</span>
          <span>o</span>
          <span>o</span>
          <span>n</span>
        </div>
      </div>
    </div>
  );
};

export default AddForm;